import React from "react";
import { Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import { useSectionContext } from "@repoflow/components/section";
import * as widgets from "widgets/register";

// What the preview composes with.
//
// A route is matched literally — there is no `/post/:slug` segment matching —
// so nothing fills `{{params.slug}}` on a served page either, and a template
// written against parameters it can never see is one nobody can check. These
// are that source: say "preview this page as if slug were about-us", and the
// composer puts them where segment matching eventually will.
//
// Saved with the page rather than kept in the browser, because the parameters
// that make a template legible are a property of the template. See
// common/schema/page/editor.
const FIELDS = {
  "/Public/Page/Update": {
    fields: [{ property: "editor", layout: "wide" }],
  },
  "/Page/Editor": {
    fields: [{ property: "params", layout: "wide" }],
  },
  "/Page/Editor/Param": {
    listing: ["name", "value"],
    fields: ["name", "value"],
  },
};

export const Content = () => {
  const { schema, target, state } = useSectionContext();

  return (
    <Row>
      <Col>
        <Form
          schema={schema}
          target={target}
          widgets={widgets}
          values={state.values}
          onChange={state.setValues}
          config={FIELDS}
        />
      </Col>
    </Row>
  );
};
